import './DownloadAPKBanner.css'
import playStore from '../../assets/play-store/get-it-on-play.png'
import { Link } from 'react-router-dom'
import { Flex } from '@mantine/core'

export default function DownloadAPKBanner({align='center', mt = '.5rem', mb, ml, mr, my, mx }){

    const styles = {
        justifyContent: align,
        marginTop: mt || my || 'unset',
        marginBottom: mb || my || 'unset',
        marginLeft: ml || mx || 'unset',
        marginRight: mr || mx || 'unset',
    }

    //padding: .5rem 0;

    return(
        <Link style={styles} to='https://play.google.com/store/apps/details?id=org.forvet.campus' target='_blank' className='DownloadAPKBanner-main-container'>
            <img className='DownloadAPKBanner-playStoreImage--sm' src={playStore} alt='Play Store' />
            <Flex align='center' gap={10}>
                <p className='DownloadAPKBanner--text'>Descargá nuestra aplicación gratis</p>
            </Flex>
        </Link>
    )
}